import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { FileLikeObject, FileUploader } from 'ng2-file-upload';
import { Country } from '@angular-material-extensions/select-country';
import { AppService } from '../services/app.service';
import { AdsService } from '../services/ads.service';
import { ToastrService } from 'ngx-toastr';
import { MatSnackBar } from '@angular/material/snack-bar';

export interface Package {
  id: number;
  name: string;
  days: string;
  cost: string;
  // image:string;
}

@Component({
  selector: 'app-createad',
  templateUrl: './createad.component.html',
  styleUrls: ['./createad.component.scss']
})
export class CreateadComponent implements OnInit {
  predefinedCountries: Country[] = [];

  countryFormControl = new FormControl();
  countryFormGroup: FormGroup;

  public uploader: FileUploader = new FileUploader({});
  adsForm: FormGroup;

  formData: any = new FormData();

  public packages: Package[] = []

  highlightedPackage: Package = null;

  myCreatedAds:any = []
 

  constructor(private formBuilder: FormBuilder, private appService: AppService, private adsService: AdsService,
    private toastr: ToastrService,
    private _snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.countryFormGroup = this.formBuilder.group({
      country: []
    });
    this.adsForm = this.formBuilder.group({
      name: '',
      description: '',
      url: '',
      country: '123',
      img: [null]
    });
    this.appService.getCountries().then((res: any) => {
      if (res.success) {
        for (let i = 0; i < res.countries.length; i++) {
          this.predefinedCountries.push({
            name: res.countries[i].countryname,
            alpha2Code: res.countries[i].code,
            alpha3Code: res.countries[i].countrycode,
            numericCode: res.countries[i].id
          })
        
        }
      }
    })
    this.adsService.getPackages().then((res:any) => {
      if(res.success){
        console.log(res)
        for(let i=0; i<res.packages.length; i++) {
          this.packages.push({
            id: res.packages[i].id,
            name: res.packages[i].name,
            cost: res.packages[i].cost,
            days: res.packages[i].days
          })
        }
      }
    })
    this.adsService.getMyCreatedAds().then((res:any) => {
      if(res.success){
        console.log(res)
        this.myCreatedAds=res.ads.data
        console.log(this.myCreatedAds)

      }
    })
  }

  onCountrySelected($event: Country) {
    
    console.log($event.numericCode)
    this.formData.append("country", $event.numericCode);
    
  }


  getFiles(): FileLikeObject[] {
    return this.uploader.queue.map((fileItem) => {
      return fileItem.file;
    });
  }

  url;
  msg = "";

  selectFile(event) {

    if (!event.target.files[0] || event.target.files[0].length == 0) {
      this.msg = 'You must select an image';
      return;
    }

    var mimeType = event.target.files[0].type;

    if (mimeType.match(/image\/*/) == null) {
      this.msg = "Only images are supported";
      return;
    }

    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (_event) => {
      this.msg = "";
      this.url = reader.result;
    }

    const file = (event.target as HTMLInputElement).files[0];
    this.adsForm.patchValue({
      img: file
    });

    this.adsForm.get('img').updateValueAndValidity();
  }
  choosePackage(id){
    console.log(id)
    this.formData.append("package_ids", id);
  }

  submitAd(){
    this.formData.append("name", this.adsForm.get('name').value);
    this.formData.append("description", this.adsForm.get('description').value);
    this.formData.append("link", this.adsForm.get('url').value);
    this.formData.append("image", this.adsForm.get('img').value);
    this.formData.append("country", "123")
    this.adsService.userCreateAd(this.formData).then((res:any) => {
      if(res.success){
      this.adsForm.reset();
      this.url = "";
      this.msg = "";this.toastr.success(
        'Your ad has been successfully submitted, our team will review your submission and you will be notified accordingly',
        'Ad Submitted', {
        timeOut: 6000,
        progressBar: true,
        closeButton: true
      });
      this.adsService.getMyCreatedAds().then((res:any) => {
        if(res.success){
          this.myCreatedAds=res.ads.data
        }
      })
    }
    else {
      this._snackBar.open(res.error, '', {
        duration: 5000,
        panelClass: ['error-snackbar'],
        verticalPosition: 'top',

      });
    }
  })
    .catch((error) => {
      console.log(error)
    });
  }

}
